module.exports = __webpack_public_path__ + "media/images/icons/consultation-02-c5f12a2327696925f1f3025aef009543.svg";